import {createRouter,createWebHashHistory} from "vue-router"
// import weixin from "@/common/weixin"
import tool from "@/common/tool"
// import config from "@/common/config"
import axios from "@/common/axios"
import urls from "@/common/urls"
import store from "@/store"
const routeType = {
  common:"common",
  ignore:"ignore"
}
const commonRoutes = [
  //员工审批
  {
    path: '/employeeAudit',
    name: 'employeeAudit',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/employeeAudit.vue')
  },
  //供应商审批
  {
    path: '/supplierAudit',
    name: 'supplierAudit',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/supplierAudit.vue')
  },
  //客户审批
  {
    path: '/customerAudit',
    name: 'customerAudit',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/customerAudit.vue')
  },
  //内部费用初审
  {
    path: '/applyCostInteriorAudit',
    name: 'applyCostInteriorAudit',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/applyCostInteriorAudit.vue')
  },
  //内部费用二次审批
  {
    path: '/applyCostInteriorSecondAudit',
    name: 'applyCostInteriorSecondAudit',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/applyCostInteriorSecondAudit.vue')
  },
  //外部费用初审
  {
    path: '/applyCostWithoutAudit',
    name: 'applyCostWithoutAudit',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/applyCostWithoutAudit.vue')
  },
  //外部费用二次审批
  {
    path: '/applyCostWithoutSecondAudit',
    name: 'applyCostWithoutSecondAudit',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/applyCostWithoutSecondAudit.vue')
  },
  //项目号申请审批
  {
    path: '/projectNumberAudit',
    name: 'projectNumberAudit',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/projectNumberAudit.vue')
  },
  //新增项目号&操作人审批
  {
    path: '/createProjectNumber',
    name: 'createProjectNumber',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/createProjectNumber.vue')
  },
  //po合同首次审批
  {
    path: '/poContractAudit',
    name: 'poContractAudit',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/poContractAudit.vue')
  },
  //po合同二次审批
  {
    path: '/poContractSecondAudit',
    name: 'poContractSecondAudit',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/poContractSecondAudit.vue')
  },
  //po合同执行
  {
    path: '/poContractCheck',
    name: 'poContractCheck',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/poContractCheck.vue')
  },
  //用印申请首次审批
  {
    path: '/applySealAudit',
    name: 'applySealAudit',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/applySealAudit.vue')
  },
  //用印申请二次审批
  {
    path: '/applySealSecondAudit',
    name: 'applySealSecondAudit',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/applySealSecondAudit.vue')
  },
  //用印申请执行
  {
    path: '/applySealCheck',
    name: 'applySealCheck',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/applySealCheck.vue')
  },
  //结算初审
  {
    path: '/settlementAudit',
    name: 'settlementAudit',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/settlementAudit.vue')
  },
  //发票初审
  {
    path: '/applyInvoiceAudit',
    name: 'applyInvoiceAudit',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/applyInvoiceAudit.vue')
  },
  //发票二次审核
  {
    path: '/applyInvoiceSecondAudit',
    name: 'applyInvoiceSecondAudit',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/applyInvoiceSecondAudit.vue')
  },
  //发票申请执行
  {
    path: '/applyInvoiceCheck',
    name: 'applyInvoiceCheck',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/applyInvoiceCheck.vue')
  },
  //发票信息审核
  {
    path: '/invoiceInfoAudit',
    name: 'invoiceInfoAudit',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/invoiceInfoAudit.vue')
  },
  //需求发送审核
  {
    path: '/projectExecuteAudit',
    name: 'projectExecuteAudit',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/projectExecuteAudit.vue')
  },
  //撤销需求发送
  {
    path: '/repealProjectExecute',
    name: 'repealProjectExecute',
    component: () => import(/* webpackChunkName "repealProjectExecute" */ '@/components/page/project/repealProjectExecute.vue')
  },
  //指定项目Lerder
  {
    path: '/projectAssignLerder',
    name: 'projectAssignLerder',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/projectAssignLerder.vue')
  },
  //跨部门项目lerder
  {
    path: '/stretchAssignLerder',
    name: 'stretchAssignLerder',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/project/stretchAssignLerder.vue')
  }
]
const ignoreRoutes = [
  {
    path: '/',
    name: 'index',
    categary:routeType.ignore,
    component: () => import(/* webpackChunkName "index" */ '@/components/page/index.vue')
  },
  {
    path:"/index",
    categary:routeType.ignore,
    name:"index",
    component:() =>import(/* webpackChunkName: "index", webpackPrefetch: true */ "@/components/page/index.vue")
  },
  //指定项目Lerder详情页
  {
    path: '/projectAssignLerderDetail',
    name: 'projectAssignLerderDetail',
    component: () => import(/* webpackChunkName "projectAssignLerder" */ '@/components/page/project/projectAssignLerder.vue')
  },
  //跨部门项目lerder详情页
  {
    path: '/stretchAssignLerderDetail',
    name: 'stretchAssignLerderDetail',
    component: () => import(/* webpackChunkName "stretchAssignLerder" */ '@/components/page/project/stretchAssignLerder.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName "login" */ '@/components/page/login_code.vue')
  },
  {
    path:"/page404",
    categary:routeType.ignore,
    name:"page404",
    component:() =>import(/* webpackChunkName: "page404", webpackPrefetch: true */ "@/components/common/page404.vue")
  },
  {
    path:"/auditError",
    categary:routeType.ignore,
    name:"auditError",
    component:() =>import(/* webpackChunkName: "auditError", webpackPrefetch: true */ "@/components/common/auditError.vue")
  },
  {
    path:"/jump",
    categary:routeType.ignore,
    name:"jump",
    component:() =>import(/* webpackChunkName: "jump", webpackPrefetch: true */ "@/components/main/jump.vue")
  }
]
const routes =  [].concat(commonRoutes,ignoreRoutes);
// const routes =  []
const router = createRouter({
  history:createWebHashHistory(),
  routes
});
const ignorePages = ignoreRoutes.map(item=>item.name) // 不需要验证的页面
// const commonPages =  commonRoutes.map(item=>item.name)  // 通用页面,只需要openid，其他不验证


router.beforeEach((to, from, next) => {
  if (ignorePages.includes(to.name)) {
    next();
    return;
  }
  const data = tool.getLocalCookie('loginData')
  if (store.state.common.userInfo.email) {
    next()
    return;
  }
  if (data.email) {
    login(to, from, next);
    return;
  }
  tool.setStorage("toPath", to);
  next('/login');
})
// async function development(to,from,next){
//   // weixin.init()
//   // tool.setCookie("openid","oa7P258dKjvDTvsjOUrh-bF7U-LI")//相菊
//   tool.setCookie("openid","oa7P25--EoEZOBcwCSKffkd_j7zo")//相菊
//   // tool.setCookie("openid","oa7P255GOnFrDINgGkcI0CsIlV1w") //先东
//   // tool.setCookie("openid","oa7P253bWlSTXZnE4B1s-ZTa9_oM") //李俊二
//   // tool.setCookie("openid","oa7P25wVntUPmaMxLqVFA3P3pQUk") // iphone
//   if(ignorePages.includes(to.name)){  next();  return; }
//   inSystem(to,from,next)
// }
// async function produce(to,from,next){
//   // weixin.init()
//   if(ignorePages.includes(to.name)){  next();  return; }
//   let openid = tool.getCookie("openid") || "";
//   if(!openid){
//     next({name:"jump",path:"/jump",query:{path:to.path,...to.query}})
//     return;
//   }
//   inSystem(to,from,next)

// }
// async function inSystem(to,from,next){
//   // next();
//   // return;
//   let name = to.name;
//   // 可跳过 路由
//   if( commonPages.includes(name)){ // 通用页面
//     next();
//     return;
//   }else{ // 错误的路由
//     next("/page404")
//   }
  
// }

//进行登录操作
const login = (to, from, next) => {
  let data = tool.getLocalCookie("loginData")
  axios.post(urls.user.login, data).then((res) => {
    tool.getLocalCookie("loginData", data)
    tool.setStorage("userInfo", res.data)
    store.dispatch("setItem", { userInfo: res.data })
    next()
  }).catch(() => {
    // next()
    tool.setStorage("toPath", to);
    next('/login')
  })
}

// async function isRegister(to,from,next){
//   let doctorInfo = store.state.common.doctorInfo;
//   if(doctorInfo.openid) { next(); return; }
//   let url = `${urls.doctor.doctorInfo}`
//   let response = await axios.get(url)
//   if(response.data && response.data.openid){
//     store.dispatch("setItem",{doctorInfo:response.data})
//     next()
//   }else{
//     next("/information")
//   }
// }
// async function isSign(to,from,next){
//   let signInfo = store.state.common.signInfo;
//   if(signInfo.openid) { next(); return; }
//   let url = tool.getURL(urls.meet.sign,tool.getSystemInfo())
//   let response = await axios.get(url)
//   if(response.data && response.data.openid){
//     store.dispatch("setItem",{signInfo:response.data})
//     next()
//   }else{
//     next({
//       path:"/sign",
//       query:{
//         meetingId:to.params.id,
//         ...to.query
//       }
//     })
//   }
// }


export default router;